import React, { useEffect, useState } from "react";
import "./styles.css";
import Menu from "../Menu";
import Header from "../Header";
import Footer from "../Footer";
import { PageProps } from "../../interfaces/props/PageProps";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import Accessibility from "../../components/Accessibility";
import { useMediaQuery } from "@mui/material";
import Chatbot from "../../assets/camila/Chatbot";
import { getBenef } from "../../Store/storages/BeneficiarioStorage";
import { HomeProvider } from "../../Store/contexts/HomeContext";
import ICOMDesktop from "../../assets/svgs/ICOM/ICOMDesktop";
import ICOM from "../../assets/svgs/ICOM/ICOM";
import { hideCamila, showCamila } from "../../utils/CamilaUtils";

function Page(props: PageProps) {
  const { contrastStyle, contrastMode } = useAccessibility();

  const pageUri = window.location.pathname;
  const isChatPage = pageUri.includes("/chat");
  const landscapeMobile = useMediaQuery(
    "(max-width: 1130px) and (max-height: 600px)"
  );
  const isMobileWidth = useMediaQuery("(max-width: 1330px)");
  const benef = getBenef();
  const [isHovered, setIsHovered] = useState(false);

  const currentUrl = window.location.pathname;
  const isExcludedMobileRoute =
    isMobileWidth &&
    (/^\/saudeBemEstar\/gestaoDeCronicos\/conversaEquipe\/conversas\/[^/]+\/chat$/.test(currentUrl) ||
    /^\/saudeOnline\/faleComPersonal\/conversaEquipe\/conversas\/[^/]+\/chat$/.test(currentUrl));

  useEffect(() => {
    if (currentUrl.includes("/biometriaFacial") ||
        currentUrl.includes("/ingressarNoAtendimento") ||
      isExcludedMobileRoute) {
      hideCamila();
    } else {
      showCamila();
    }
  }, [currentUrl, isExcludedMobileRoute]);

  const handleRedirect = () => {
    window.open("https://icom.app/KBEqg", "_blank", "noopener,noreferrer");
  };

  return (
    <HomeProvider>
      <div className="content">
        <Menu />
        <main>
          {useMediaQuery("(max-width: 500px)") && (
            <div
              className={`preheader-content ${
                contrastMode && "black-background"
              }`}
            >
              <Accessibility />
            </div>
          )}

          {!(isChatPage && landscapeMobile) && <Header />}
          <div
            style={contrastStyle}
            className={isChatPage ? "chat-content" : "main-content"}
          >
            {props.content}
            <div
              className="icon-container"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={handleRedirect}
            >
              {!isMobileWidth ? <ICOMDesktop isHovered={isHovered} /> : <ICOM />}
            </div>
          </div>
          {!(isChatPage && landscapeMobile) && <Footer showMapaDoSite={true} />}
        </main>
        {!!benef && (
            <>
              <script
                id="gtag-manager-script"
                type="text/javascript"
                async
                src="https://mw.googletagmanager.com/gtag/js?id=UM-53299533-9"
              ></script>
              <Chatbot benef={benef} />
              <script id="gtag-script" type="text/javascript">
                {`window.dataLayer = window.dataLayer || [];
              function gtag() { dataLayer.push(arguments); }
              gtag('js', new Date());
              gtag('config', 'UA-53299533-9');
              `}
              </script>
            </>
          )}
      </div>
    </HomeProvider>
  );
}

export default Page;
